<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App"
};
</script>
<!-- 在此引入 全局通用的css样式-->
<style src="./components/base/global/css/common.css"></style>
<style src="./config/global.css"></style>




// WEBPACK FOOTER //
// src/App.vue